// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inputDialogRoot[data-v-3db8304b]
	{
		max-width: 300px;
		background-color: #FFFFFF;
}
.checkbox[data-v-3db8304b]
	{
		font-size: 15px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-bottom: 5px;
}
.checkbox label[data-v-3db8304b]
		{
}
.titleBar[data-v-3db8304b]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-3db8304b]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.messageText[data-v-3db8304b]
	{
		margin: 8px 14px;
		white-space: pre-wrap;
}
.dialogBody[data-v-3db8304b]
	{
		padding: 0px 5px 0px 5px;
}
.inputWrapper[data-v-3db8304b]
	{
		display: flex;
}
.shake .textInput[data-v-3db8304b]
	{
		outline: 3px solid #FF0000;
}
.textInput[data-v-3db8304b]
	{
		flex: 1 1 auto;
		margin: 10px 15px;
		border: 1px solid #AAAAAA;
		border-radius: 3px;
		padding: 3px 6px;
		font-size: 13pt;
}
.buttons[data-v-3db8304b]
	{
		display: flex;
}
.dialogButton[data-v-3db8304b]
	{
		display: inline-block;
		cursor: pointer;
		color: black;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-3db8304b]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.okButton[data-v-3db8304b]
	{
		color: #4A9E42;
}
.cancelButton[data-v-3db8304b]
	{
		color: #CE7D29;
		border-left: 1px solid #DDDDDD;
}
.shake[data-v-3db8304b]
	{
		-webkit-animation: kf_shake-3db8304b 0.4s 1 linear;
		-moz-animation: kf_shake-3db8304b 0.4s 1 linear;
		-o-animation: kf_shake-3db8304b 0.4s 1 linear;
		animation: kf_shake-3db8304b 0.4s linear 0 1;
}
@-webkit-keyframes kf_shake-3db8304b
	{
0%
		{
			-webkit-transform: translate(30px);
}
20%
		{
			-webkit-transform: translate(-30px);
}
40%
		{
			-webkit-transform: translate(15px);
}
60%
		{
			-webkit-transform: translate(-15px);
}
80%
		{
			-webkit-transform: translate(8px);
}
100%
		{
			-webkit-transform: translate(0px);
}
}
@-moz-keyframes kf_shake-3db8304b
	{
0%
		{
			-moz-transform: translate(30px);
}
20%
		{
			-moz-transform: translate(-30px);
}
40%
		{
			-moz-transform: translate(15px);
}
60%
		{
			-moz-transform: translate(-15px);
}
80%
		{
			-moz-transform: translate(8px);
}
100%
		{
			-moz-transform: translate(0px);
}
}
@-o-keyframes kf_shake-3db8304b
	{
0%
		{
			-o-transform: translate(30px);
}
20%
		{
			-o-transform: translate(-30px);
}
40%
		{
			-o-transform: translate(15px);
}
60%
		{
			-o-transform: translate(-15px);
}
80%
		{
			-o-transform: translate(8px);
}
100%
		{
			-o-origin-transform: translate(0px);
}
}
@keyframes kf_shake-3db8304b
	{
0%
		{
			transform: translate(30px);
}
20%
		{
			transform: translate(-30px);
}
40%
		{
			transform: translate(15px);
}
60%
		{
			transform: translate(-15px);
}
80%
		{
			transform: translate(8px);
}
100%
		{
			transform: translate(0px);
}
}
`, "",{"version":3,"sources":["webpack://./www/vues/common/controls/TextInputPopup.vue"],"names":[],"mappings":";AA0IC;;EAEC,gBAAgB;EAChB,yBAAyB;AAC1B;AAEA;;EAEC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACnB;AAEC;;AAEA;AAED;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAGA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,gBAAgB;EAChB,qBAAqB;AACtB;AAEA;;EAEC,wBAAwB;AACzB;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,0BAA0B;AAC3B;AAEA;;EAEC,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AAChB;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,cAAc;AACf;AAEA;;EAEC,cAAc;EACd,8BAA8B;AAC/B;AAEA;;EAEC,kDAAyC;EACzC,+CAAsC;EACtC,6CAAoC;EACpC,4CAAmC;AACpC;AAEA;;AAEC;;GAEC,kCAAkC;AACnC;AAEA;;GAEC,mCAAmC;AACpC;AAEA;;GAEC,kCAAkC;AACnC;AAEA;;GAEC,mCAAmC;AACpC;AAEA;;GAEC,iCAAiC;AAClC;AAEA;;GAEC,iCAAiC;AAClC;AACD;AAEA;;AAEC;;GAEC,+BAA+B;AAChC;AAEA;;GAEC,gCAAgC;AACjC;AAEA;;GAEC,+BAA+B;AAChC;AAEA;;GAEC,gCAAgC;AACjC;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,8BAA8B;AAC/B;AACD;AAEA;;AAEC;;GAEC,6BAA6B;AAC9B;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,6BAA6B;AAC9B;AAEA;;GAEC,8BAA8B;AAC/B;AAEA;;GAEC,4BAA4B;AAC7B;AAEA;;GAEC,mCAAmC;AACpC;AACD;AAEA;;AAEC;;GAEC,0BAA0B;AAC3B;AAEA;;GAEC,2BAA2B;AAC5B;AAEA;;GAEC,0BAA0B;AAC3B;AAEA;;GAEC,2BAA2B;AAC5B;AAEA;;GAEC,yBAAyB;AAC1B;AAEA;;GAEC,yBAAyB;AAC1B;AACD","sourcesContent":["<template>\r\n\t<div :class=\"{ inputDialogRoot: true, shake: shake }\" ref=\"dialogRoot\" role=\"dialog\" aria-labelledby=\"textInputMsgTitle\" aria-describedby=\"textInputMsg\">\r\n\t\t<div v-if=\"title\" class=\"titleBar\">\r\n\t\t\t<div id=\"textInputMsgTitle\" class=\"title\" role=\"alert\">{{title}}</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<div id=\"textInputMsg\" class=\"messageText\" v-if=\"message\">{{message}}</div>\r\n\t\t\t<div class=\"inputWrapper\">\r\n\t\t\t\t<input type=\"text\" ref=\"inputText\" :placeholder=\"placeholder\" v-model=\"value\" @keypress.enter=\"okClicked\" v-bind:maxlength=\"maxTextLength\" class=\"textInput\" name=\"do-not-autofill\" data-bwignore=\"true\" data-lpignore=\"true\" autocomplete=\"off\" />\r\n\t\t\t</div>\r\n\t\t\t<div class=\"inputWrapper checkbox\" v-if=\"checkboxText\">\r\n\t\t\t\t<input :id=\"uid + 'cb'\" type=\"checkbox\" v-model=\"checked\" class=\"textInput\" /><label :for=\"uid + 'cb'\">{{checkboxText}}</label>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"buttons\">\r\n\t\t\t\t<div class=\"dialogButton okButton\" tabindex=\"0\" @click=\"okClicked\" @keydown.space.enter.prevent=\"okClicked\">\r\n\t\t\t\t\tOK\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"dialogButton cancelButton\" tabindex=\"0\" @click=\"cancelClicked\" @keydown.space.enter.prevent=\"cancelClicked\">\r\n\t\t\t\t\tCancel\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\tlet animationEvents = [\"webkitAnimationEnd\", \"oanimationend\", \"msAnimationEnd\", \"animationend\"];\r\n\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\ttitle: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: null\r\n\t\t\t},\r\n\t\t\tmessage: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t},\r\n\t\t\tplaceholder: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t},\r\n\t\t\tinitialText: {\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: \"\"\r\n\t\t\t},\r\n\t\t\tmaxTextLength: {\r\n\t\t\t\ttype: Number,\r\n\t\t\t\tdefault: 4096\r\n\t\t\t},\r\n\t\t\tcheckboxText: {  // If not null, a checkbox will appear labeled with this text.  If not null, the returned value from this dialog becomes an object containing a string and a bool, rather than just a string.\r\n\t\t\t\ttype: String,\r\n\t\t\t\tdefault: null\r\n\t\t\t}\r\n\t\t},\r\n\t\tdata()\r\n\t\t{\r\n\t\t\treturn {\r\n\t\t\t\tvalue: \"\",\r\n\t\t\t\tshake: false,\r\n\t\t\t\tchecked: false,\r\n\t\t\t\tuid: \"TextInputPopup\" + GetUid() // Vue 3 does not expose the internal _uid, so generate our own unique id for input/label wiring.\r\n\t\t\t};\r\n\t\t},\r\n\t\tmounted()\r\n\t\t{\r\n\t\t\tthis.value = \" \";\r\n\t\t\tthis.$nextTick(() =>\r\n\t\t\t{\r\n\t\t\t\t// Necessary to work around a glitch where iOS 10 displays the placeholder and the text on top of eachother.\r\n\t\t\t\tif (this.initialText)\r\n\t\t\t\t\tthis.value = this.initialText;\r\n\t\t\t\telse\r\n\t\t\t\t\tthis.value = \"\";\r\n\r\n\t\t\t\tif (this.$refs.inputText)\r\n\t\t\t\t\tthis.$refs.inputText.focus();\r\n\t\t\t\tthis.$nextTick(() =>\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.$refs.inputText)\r\n\t\t\t\t\t\tthis.$refs.inputText.setSelectionRange(0, this.$refs.inputText.value.length); // select all text so the user can simply begin typing\r\n\t\t\t\t});\r\n\t\t\t});\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t\tif (this.$refs.inputText)\r\n\t\t\t\t\tthis.$refs.inputText.focus();\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t},\r\n\t\t\tokClicked()\r\n\t\t\t{\r\n\t\t\t\tif (this.value)\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.checkboxText)\r\n\t\t\t\t\t\tthis.$emit(\"close\", { value: this.value, checked: this.checked });\r\n\t\t\t\t\telse\r\n\t\t\t\t\t\tthis.$emit(\"close\", { value: this.value });\r\n\t\t\t\t}\r\n\t\t\t\telse\r\n\t\t\t\t{\r\n\t\t\t\t\tthis.startShaking();\r\n\t\t\t\t}\r\n\t\t\t},\r\n\t\t\tcancelClicked()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"close\");\r\n\t\t\t},\r\n\t\t\tstartShaking()\r\n\t\t\t{\r\n\t\t\t\tif (this.shake)\r\n\t\t\t\t\treturn;\r\n\t\t\t\tanimationEvents.forEach(event =>\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.$refs.dialogRoot)\r\n\t\t\t\t\t\tthis.$refs.dialogRoot.addEventListener(event, this.animationEnd);\r\n\t\t\t\t});\r\n\t\t\t\tthis.shake = true;\r\n\t\t\t},\r\n\t\t\tanimationEnd(e)\r\n\t\t\t{\r\n\t\t\t\tthis.shake = false;\r\n\t\t\t\tanimationEvents.forEach(event =>\r\n\t\t\t\t{\r\n\t\t\t\t\tif (this.$refs.dialogRoot)\r\n\t\t\t\t\t\tthis.$refs.dialogRoot.removeEventListener(event, this.animationEnd);\r\n\t\t\t\t});\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.inputDialogRoot\r\n\t{\r\n\t\tmax-width: 300px;\r\n\t\tbackground-color: #FFFFFF;\r\n\t}\r\n\r\n\t.checkbox\r\n\t{\r\n\t\tfont-size: 15px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\t\tjustify-content: center;\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\r\n\t\t.checkbox label\r\n\t\t{\r\n\t\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.messageText\r\n\t{\r\n\t\tmargin: 8px 14px;\r\n\t\twhite-space: pre-wrap;\r\n\t}\r\n\r\n\t.dialogBody\r\n\t{\r\n\t\tpadding: 0px 5px 0px 5px;\r\n\t}\r\n\r\n\t.inputWrapper\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.shake .textInput\r\n\t{\r\n\t\toutline: 3px solid #FF0000;\r\n\t}\r\n\r\n\t.textInput\r\n\t{\r\n\t\tflex: 1 1 auto;\r\n\t\tmargin: 10px 15px;\r\n\t\tborder: 1px solid #AAAAAA;\r\n\t\tborder-radius: 3px;\r\n\t\tpadding: 3px 6px;\r\n\t\tfont-size: 13pt;\r\n\t}\r\n\r\n\t.buttons\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.okButton\r\n\t{\r\n\t\tcolor: #4A9E42;\r\n\t}\r\n\r\n\t.cancelButton\r\n\t{\r\n\t\tcolor: #CE7D29;\r\n\t\tborder-left: 1px solid #DDDDDD;\r\n\t}\r\n\r\n\t.shake\r\n\t{\r\n\t\t-webkit-animation: kf_shake 0.4s 1 linear;\r\n\t\t-moz-animation: kf_shake 0.4s 1 linear;\r\n\t\t-o-animation: kf_shake 0.4s 1 linear;\r\n\t\tanimation: kf_shake 0.4s linear 0 1;\r\n\t}\r\n\r\n\t@-webkit-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-webkit-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@-moz-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-moz-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@-o-keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\t-o-transform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\t-o-transform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\t-o-transform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\t-o-transform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\t-o-transform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\t-o-origin-transform: translate(0px);\r\n\t\t}\r\n\t}\r\n\r\n\t@keyframes kf_shake\r\n\t{\r\n\t\t0%\r\n\t\t{\r\n\t\t\ttransform: translate(30px);\r\n\t\t}\r\n\r\n\t\t20%\r\n\t\t{\r\n\t\t\ttransform: translate(-30px);\r\n\t\t}\r\n\r\n\t\t40%\r\n\t\t{\r\n\t\t\ttransform: translate(15px);\r\n\t\t}\r\n\r\n\t\t60%\r\n\t\t{\r\n\t\t\ttransform: translate(-15px);\r\n\t\t}\r\n\r\n\t\t80%\r\n\t\t{\r\n\t\t\ttransform: translate(8px);\r\n\t\t}\r\n\r\n\t\t100%\r\n\t\t{\r\n\t\t\ttransform: translate(0px);\r\n\t\t}\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
